import React from "react"
import { connect } from "react-redux"
import Checkbox from "react-bootstrap/lib/Checkbox"
import * as actionCreators from "../redux/action_creators"
import { alerts } from "../util/alert_error_utils"
import { makeToast } from "../util/toast_util"
import { appStrings } from "../common/strings/app_strings"
import OnboardingSection from "../components/onboarding/onboarding_section"
import { SettingsFormField } from "../components/settings/settings_form_field"
import { appNums } from "../common/nums/app_nums"
import {
    TERMS_OF_SERVICE_URL,
    PRIVACY_POLICY_URL,
} from "../common/constants/app_consts"
const {
    nameAndPasswordTitle,
    continueButton,
    fullName,
    placeholder,
    welcome,
    iAgree,
    terms,
    privacyPolicy,
    and,
} = appStrings.onboarding

const { MIN_PASSWORD_LENGTH } = appNums
class NameAndPassword extends React.Component {
    constructor() {
        super()

        this.state = {
            fullName: "",
            password: "",
            agreeToTerms: false,
        }
        this.textInput = null
        this.setTextInputRef = element => (this.textInput = element)
        this.focusTextInput = () => {
            if (this.textInput) this.textInput.focus()
        }
    }

    componentDidMount = () => {
        const { currentInvite } = this.props
        if (currentInvite) {
            this.setState({ fullName: currentInvite.invitedFullName })
        }
    }

    componentDidUpdate = prevProps => {
        const { currentInvite } = this.props
        const { currentInvite: prevCurrentInvite } = prevProps
        if (
            currentInvite &&
            !prevCurrentInvite &&
            currentInvite.invitedFullName
        ) {
            // set name
            this.setState(
                { fullName: currentInvite.invitedFullName },
                // focus password field
                () => this.focusTextInput(),
            )
        }
    }

    handleNavigateAndPatch = () => {
        const { password, fullName, agreeToTerms } = this.state
        const patchMeta = {
            fullName,
            password,
            agreeToTerms,
        }
        const { handleNavigateAndPatch } = this.props

        if (password.length < MIN_PASSWORD_LENGTH) {
            const { msg } = alerts["passwordTooShort"]
            makeToast(msg, "danger")
            this.focusTextInput()
            return
        }

        if (!agreeToTerms) {
            const { msg } = alerts["agreeToTerms"]
            makeToast(msg, "danger")
            return
        }

        handleNavigateAndPatch(patchMeta)
    }

    fieldSetter = (value, key) => this.setState({ [key]: value })

    toggleTerms = () => {
        const agreeToTerms = !this.state.agreeToTerms
        this.setState({ agreeToTerms })
    }

    render() {
        const { currentInvite } = this.props
        const isTeamOnboarding = !!currentInvite
        const sectionTitle = isTeamOnboarding ? welcome : nameAndPasswordTitle
        const sectionDetail =
            isTeamOnboarding &&
            `${currentInvite.inviterFullName ||
                currentInvite.inviterEmail} has invited you to track time for
            ${currentInvite.teamName} on Shoutbase.`

        return (
            <OnboardingSection
                sectionTitle={sectionTitle}
                buttonValue={continueButton}
                onClickAction={this.handleNavigateAndPatch}
                hasSkipButton={false}
                isWide={false}
            >
                {isTeamOnboarding && (
                    <p className="col-md-12">{sectionDetail}</p>
                )}
                <div className="col-md-12 form-group">
                    <SettingsFormField
                        focus={true}
                        id="fullName"
                        placeholder={fullName}
                        tabIndex="1"
                        value={this.state.fullName}
                        onChangeAction={this.fieldSetter}
                        preventAutoComplete={true}
                    />
                </div>
                <div className="col-md-12 form-group">
                    <SettingsFormField
                        id="password"
                        placeholder={placeholder}
                        type="password"
                        tabIndex="2"
                        value={this.state.password}
                        onChangeAction={this.fieldSetter}
                        setRef={this.setTextInputRef}
                        preventAutoComplete={true}
                    />
                </div>
                <Checkbox
                    checked={this.state.agreeToTerms}
                    onChange={this.toggleTerms}
                >
                    <p className="terms-and-conditions">
                        {iAgree}{" "}
                        <a href={TERMS_OF_SERVICE_URL} target="_blank">
                            {terms}
                        </a>
                        {and}
                        <a href={PRIVACY_POLICY_URL} target="_blank">
                            {privacyPolicy}
                        </a>
                    </p>
                </Checkbox>
            </OnboardingSection>
        )
    }
}

function mapStateToProps(state) {
    return state
}
export default connect(
    mapStateToProps,
    actionCreators,
)(NameAndPassword)



// WEBPACK FOOTER //
// ./src/pages/name_and_password.jsx